import { render, staticRenderFns } from "./afterSaleDrawer.vue?vue&type=template&id=01313425&scoped=true"
import script from "./afterSaleDrawer.vue?vue&type=script&lang=js"
export * from "./afterSaleDrawer.vue?vue&type=script&lang=js"
import style0 from "./afterSaleDrawer.vue?vue&type=style&index=0&id=01313425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01313425",
  null
  
)

export default component.exports